import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const isLanding = location.pathname === '/';
  const links = [{
    href: '/find-hostel',
    label: 'Find Hostel'
  }, {
    href: '/roommate-match',
    label: 'Roommate Match'
  }, {
    href: '/marketplace',
    label: 'Marketplace'
  }, {
    href: '/ambassadors',
    label: 'Ambassadors'
  }];
  return <nav className={`absolute top-0 w-full z-40 px-6 py-6 ${!isLanding ? 'bg-white border-b border-slate-100' : ''}`} data-id="element-252" data-mp="f0lqkv6sul76">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-253" data-mp="szlg0524z44e">
        <Link to="/" className="flex items-center gap-2 z-50" data-id="element-254" data-mp="oz1iv1hkc0i9">
          <img src="https://cdn.magicpatterns.com/uploads/37CjFFhCaYFTTZ1oinSNtZ/Cam_main_ver_logo.png" alt="CampusAparte" className="h-10 w-auto" data-id="element-255" data-mp="p0mbumo8bbe0" />
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex gap-8 text-sm font-medium text-slate-600 items-center" data-id="element-256" data-mp="mgnhe8mgkxsw">
          {links.map(link => <Link key={link.href} to={link.href} className={`transition-colors ${location.pathname === link.href ? 'text-brand-primary font-semibold' : 'hover:text-brand-primary'}`} data-id="element-257" data-mp="rgi7i9yetjcw">
              {link.label}
            </Link>)}
          <Link to="/login" data-id="element-258" data-mp="157wv6u39i8qa">
            <Button variant="ghost" size="sm" className="font-semibold text-brand-dark hover:text-brand-primary" data-id="element-259" data-mp="157nclrkjr3um">
              Login
            </Button>
          </Link>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden z-50 text-brand-dark" onClick={() => setIsOpen(!isOpen)} data-id="element-260" data-mp="1k4xnozta27pt">
          {isOpen ? <X data-id="element-261" data-mp="udwbehb128p6" /> : <Menu data-id="element-262" data-mp="udnumebsaj8p" />}
        </button>

        {/* Mobile Menu Overlay */}
        <AnimatePresence data-id="element-263" data-mp="piguthlmxyp2">
          {isOpen && <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} className="absolute inset-0 top-0 left-0 w-full h-screen bg-white flex flex-col items-center justify-center gap-8 md:hidden z-40" data-id="element-264" data-mp="146br17yuql6w">
              {links.map(link => <Link key={link.href} to={link.href} className="text-xl font-medium text-brand-dark hover:text-brand-primary" onClick={() => setIsOpen(false)} data-id="element-265" data-mp="1i51owpthwowb">
                  {link.label}
                </Link>)}
              <Link to="/login" onClick={() => setIsOpen(false)} data-id="element-266" data-mp="1zfyjw3bvnaex">
                <Button size="lg" className="w-40" data-id="element-267" data-mp="24e0arafjoe0y">
                  Login
                </Button>
              </Link>
            </motion.div>}
        </AnimatePresence>
      </div>
    </nav>;
}